/**
 * K线图收盘价面积图
 */
import {
  LINE_TYPE
} from '../setting.js';
import KLineState from '../kline'
import Util, {mergeModelData, curryFun} from '../../util/index.js';
const model = {
  close_px: {
    Type: Object,
    Default: () => ({})
  }
};
export default class KLineCloseLineState extends KLineState {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  // 计算纵轴范围
  _calcRange() {
    const {close_px} = this.state.data;
    this.calcRange({data: close_px, targetKey: 'value', isAdditional: true});
    this.baseValue = (this.maxValue + this.minValue) / 2;
  }
  // 计算各个点的Y轴坐标
  _calcAxis() {
    const {close_px} = this.state.data;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: close_px});
  }
  _drawMain() {
    const {
      left,
      bottom,
      barWidth
    } = this.availArea;
    const {close_px} = this.state.data;
    const {closeLine: closeOption, gridentColor} = this.option.KLine.closePx;
    const {LINE, GRIDENT} = LINE_TYPE;//折线,渐变折线
    this._drawLine(GRIDENT, close_px, left+barWidth/2, bottom, closeOption.lineWidth, gridentColor);
    this._drawLine(LINE, close_px, left, bottom, closeOption.lineWidth, closeOption.color);
  }
  _calcCursorAxis(index) {
    const {kline, start, close_px} = this.state.data;
    /*** 绘制Y轴标签 ***/
    const data = close_px[index];
    if (data) {
      const text = data.value;
      const y = data.lineY;
      return {text, y}
    }
  }
  _drawTitle() {
    const ctx2 = this.curContext;
    const {current, sealObj} = this.state.data;
    const {height, top, baseSize} = this.state;
    const {ratioFixed} = sealObj;
    const {baseLine} = this.option.MainContext.title;
    const baseLineY = top + height * baseLine;
    let {left} = this.availArea;
    const data = this.state.data.close_px
    const {
      sizeRatio,
      fontFamily,
      color,
      space
    } = this.option.KLine.closePx;
    ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    ctx2.fillStyle = color;
    ctx2.textAlign = 'left';
    ctx2.textBaseline = 'middle';
    ctx2.beginPath();
    const item = data[current];
    if (Util.isDef(item) && Util.isValidNumber(item.value)) {
      const text = '收盘价: ' + item.value.toFixed(ratioFixed);
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth;
    } else {
      const text = '收盘价: -';
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth;
    }
    left += space * this.dpr;
  }
}
